module.exports = __webpack_public_path__ + "img/homepage_2--mobile@2x.fef65cd6.jpg";